import React, { useState, useEffect } from "react";
// import BlockedImg from "../../../assets/images/icons/error-icon.png";
import { FallbackProps } from 'react-error-boundary';
import { t } from '@utils/translations';

const ErrorBoundaryScreen: React.FC<FallbackProps> = ({ error }) => {

    const [hasError, setHasError] = useState<boolean>(false);
    const [errorCode, setErrorCode] = useState<number | null>(null);

    useEffect(() => {
        if (error instanceof Error) {
            handleChunkLoadError(error);
        }
    }, [error]);

    const handleChunkLoadError = (err: Error) => {
        if (err?.message && err.message.includes("Loading chunk")) {
            setHasError(true);
            setErrorCode(403);
        }
    };

    const rootClassName = "p-2.5";
    const containerClassName = "p-5 my-[50px] mx-auto max-w-[600px] rounded-lg text-[#333] text-center box-border max-[600px]:p-4 max-[600px]:my-5 max-[600px]:max-w-[90%]";
    const headerClassName = "text-[#333] text-center font-bold text-xl leading-[30px]";
    const messageClassName = "text-[#827C71] text-center text-sm font-normal leading-[21px] mb-5 max-[600px]:text-base max-[600px]:mb-4";

    return (
        <>
            {hasError ? (
                <div className={rootClassName}>
                    <div role="alert" className={containerClassName}>
                        {/* <img
                            src={require("../../../assets/images/icons/error-403.jpg")}
                            alt=""
                            className="w-[30%] pb-[40%]"
                        /> */}
                        <h2 className={headerClassName}>
                            Error {errorCode}: Unable to Load Application
                        </h2>
                        <p className={messageClassName}>
                            It seems some files can't be fetched from the server (403
                            Forbidden).
                        </p>
                        <p className={messageClassName}>
                            Please try refreshing the page, or contact support if the issue
                            persists.
                        </p>
                    </div>
                </div>
            ) : (
                <div className={rootClassName}>
                    <div role="alert" className={containerClassName}>
                        {/* <img src={BlockedImg} alt="" className="w-[30%] pb-[40%]" /> */}
                        <h2 className={headerClassName}>{t('common.genericError')}</h2>
                        {/* <pre className="text-[#a60000] text-sm whitespace-pre-wrap wrap-break-word max-[600px]:text-xs">{error?.message ?? 'No error details available.'}</pre> */}
                    </div>
                </div>
            )}
        </>
    );
};

export default ErrorBoundaryScreen;